import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  boxInput: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '12vw',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      height: 'fit-content',
      minHeight: '10px',
      justifyContent: 'flex-start',
    },
  },
}))

export default styles
